<template>
  <div class="face-pills-wrapper flex items-center" :class="colorClass">
      <div class="face-icon-wrapper">
        <img :src="faceIcon">   
    </div>
    <div class="border"></div>
    <div class="text text-shadow-strong">{{text}}</div>
  </div>
</template>

<script>
export default {
    props: ['type'],
    data() {
        return {
            faceIcon: null,
            colorClass: null,
            text: null
        }
    },
    created() {
        this.setValues()
    },
    methods: {
        setValues() {
            switch (this.type) {
                case 'good':
                    this.faceIcon = require('@/assets/images/smiley-faces/good.svg');
                    this.text = '1. Good';
                    this.colorClass = 'bg-aqi-blue';
                    break;
                case 'moderate':
                    this.faceIcon = require('@/assets/images/smiley-faces/moderate.svg');
                    this.text = '2. Moderate';
                    this.colorClass = 'bg-aqi-yellow';
                    break;
                case 'inadequate':
                    this.faceIcon = require('@/assets/images/smiley-faces/inadequate.svg');
                    this.text = '3. Inadequate';
                    this.colorClass = 'bg-aqi-orange';
                    break;
                case 'bad':
                    this.faceIcon = require('@/assets/images/smiley-faces/bad.svg');
                    this.text = '4. Bad';
                    this.colorClass = 'bg-aqi-red';
                    break;
                case 'veryBad':
                    this.faceIcon = require('@/assets/images/smiley-faces/very-bad.svg');
                    this.text = '5. Very Bad';
                    this.colorClass = 'bg-aqi-purple';
                    break;
            
                default:
                    break;
            }
        }
    }

}
</script>

<style lang="scss">
.face-pills-wrapper{
    border-radius: 100px;
    height: 50px;
    padding: 5px;
    
 .face-icon-wrapper {
    width: 40px;
    img {
        filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .2));
    }
    //margin-left: 5px;
 }
 .border {
     border-right: 2px solid white;
     height: 30px;
     margin: 0 10px 0 10px;
 }
 .text {
     color: white;
     font-size: 1.2rem;
     //margin-left: 10px;
     margin-right: 15px;
     line-height: 1em;
 }
 &.bg-aqi-yellow {
     .text {
         color: #444444;
         text-shadow: none;
     }
 }
}
</style>